import { ApiProject, ApiSimpleComponent } from "@incendium/api";
import { personalisationService } from "Apis";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetch = async (selectedProject: ApiProject | null) => {
  if (selectedProject) {
    const res =
      await personalisationService.personalisationServiceListLanderTemplateComponents(
        {
          projectId: selectedProject.id as number,
        }
      );
    return res.components || [];
  }
  return [];
};
export const useLanderTemplates = () => {
  const { state, setState, loading, refetch, fetched } = useProjectSharedState<
    ApiSimpleComponent[]
  >("landerTemplates", [], fetch);

  return {
    templates: state,
    setTemplates: setState,
    loading,
    refetch,
    fetched,
  };
};
